// removed by extract-text-webpack-plugin
module.exports = {"Info":"Info__Info__XP_A_"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Info/Info.css
// module id = 107
// module chunks = 0